// extracted by mini-css-extract-plugin
export var banner = "_3p-0";
export var icon = "_3p-1";
export var message = "_3p-2";